import React, { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Truck } from "@phosphor-icons/react";
import { toast, Toaster } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) return toast.error("Passwords don't match");
    if (pw.length < 6) return toast.error("Password must be at least 6 characters");
    setSubmitting(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success("Password reset. Please sign in.");
      setTimeout(() => navigate("/login"), 900);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <Toaster position="top-right" />
      <div className="min-h-screen flex items-center justify-center bg-[#F4F4F5] p-8" data-testid="reset-password-page">
        <div className="w-full max-w-sm">
          <div className="flex items-center gap-2.5 mb-10">
            <img src="/brand/kanal-logo.svg" alt="Kanal" className="h-10 w-10" />
            <div className="font-semibold text-lg" style={{ fontFamily: "Work Sans" }}>
              Kanal
            </div>
          </div>

          <h1 className="text-3xl font-semibold tracking-tight mb-2" style={{ fontFamily: "Work Sans" }}>
            Reset password
          </h1>
          <p className="text-sm text-zinc-500 mb-8">Choose a new password for your account.</p>

          {!token ? (
            <div className="text-sm text-red-600">Missing token. <Link className="underline" to="/forgot-password">Request a new link</Link>.</div>
          ) : (
            <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
              <div>
                <Label className="text-xs font-semibold uppercase tracking-wider text-zinc-600">New password</Label>
                <Input type="password" required value={pw} onChange={(e) => setPw(e.target.value)} className="mt-1.5" data-testid="reset-pw" />
              </div>
              <div>
                <Label className="text-xs font-semibold uppercase tracking-wider text-zinc-600">Confirm</Label>
                <Input type="password" required value={pw2} onChange={(e) => setPw2(e.target.value)} className="mt-1.5" data-testid="reset-pw2" />
              </div>
              <Button type="submit" disabled={submitting} className="w-full bg-[#002BF6] hover:bg-[#0021C7] text-white h-10" data-testid="reset-submit-btn">
                {submitting ? "Saving…" : "Reset password"}
              </Button>
            </form>
          )}
        </div>
      </div>
    </>
  );
}
